import { DEFAULT_LOCALE } from '@constants'
import LOCALES from 'constants/locales'

const getLocaleFromPathname = (pathname: string) => {
  const parsedPathName = pathname.split('/').filter(p => p !== '')

  if (parsedPathName.length === 0) {
    return { locale: DEFAULT_LOCALE, pathname }
  }

  const locale = LOCALES.reduce((acc, locale) => {
    if (acc !== DEFAULT_LOCALE) {
      return acc
    }
    const { code } = locale

    if (code && parsedPathName.some(name => name === code)) {
      return code
    }

    return acc
  }, DEFAULT_LOCALE)

  return { locale, pathname }
}

export default getLocaleFromPathname
